import { render, staticRenderFns } from "./CarouselEvent.vue?vue&type=template&id=3aadcac2&"
import script from "./CarouselEvent.vue?vue&type=script&lang=js&"
export * from "./CarouselEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports